import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import getTimezones from "./timezones";
import { defaultOptionsStyle } from "../../styled/details/stylesSelect";
import TldrChakraSelect from "../../common/TldrChakraSelect";

const TimezonePicker = ({ value, sx, ...props }) => {
  const timezones = useMemo(() => getTimezones(), []);
  const selectedItem = useMemo(() => {
    if (value) {
      return timezones.find((item) => item.value === value) || null;
    }

    return null;
  }, [value, timezones]);

  return (
    <TldrChakraSelect
      {...props}
      chakraStyles={defaultOptionsStyle}
      styles={{
        menuPortal: (provided) => ({
          ...provided,
          zIndex: "var(--chakra-zIndices-popover)",
        }),
      }}
      menuPortalTarget={document.body}
      options={timezones}
      value={selectedItem}
      classNamePrefix="chakra-react-select"
    />
  );
};

TimezonePicker.defaultProps = {
  value: null,
};

TimezonePicker.propTypes = {
  value: PropTypes.string,
};

export default memo(TimezonePicker);
